let parseDateTime = {
    methods: {
        parseDateTime(data) {
            if (data && data.length) {
                let newData = new Date(data);
                let options = {
                    hour: 'numeric',
                    minute: 'numeric',
                };
                return newData.toLocaleString('en-US', options);
            } else {
                return '-';
            }
        },
    },
};

export default parseDateTime;